 const  cartItems= [
    {
      id: 1,
      title: 'Samsung Galaxy S7',
      price: 721.98,
      img:
        'https://res.cloudinary.com/diqqf3eq2/image/upload/v1583368215/phone-2_ohtt5s.png',
      amount: 1,
    },
    {
      id: 2,
      title: 'google pixel ',
      price: 499.31,
      img:
        'https://res.cloudinary.com/diqqf3eq2/image/upload/v1583371867/phone-1_gvesln.png',
      amount: 1,
    },
    {
      id: 3,
      title: 'Xiaomi Redmi Note 2',
      price: 342.67,
      img:
        'https://res.cloudinary.com/diqqf3eq2/image/upload/v1583368224/phone-3_h2s6fo.png',
      amount: 1,
    },
  ]
  export default cartItems;